<template>
    <el-drawer
        title="调整库存"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-alert v-if="itemData && itemData.id" type="warning" show-icon :closable="false" title="请注意：由于时效的原因，你当前看到的剩余票数可能已经产生变动"></el-alert>
            <el-form
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
                class="MT10"
            >
                <el-form-item prop="stockType">
                    <span slot="label">调整类型: <small>提交前请先选择是增加还是减少剩余库存</small></span>
                    <el-radio-group v-model="formDatas.type" size="medium" @change="changeStock">
                        <el-radio :label="1" border>增加</el-radio>
                        <el-radio :label="2" border>减少</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="num" label="调整数量:">
                    <el-input-number style="width:100%" v-model="formDatas.num" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" @change="changeStock" placeholder="请输入调整数量"></el-input-number>
                </el-form-item>
            </el-form>
            <el-table
                v-if="itemData"
                :data="[1]"
                style="width: 100%"
                size="small"
                border
                header-row-class-name="page-list-table"
            >
                <el-table-column label="总库存">
                    <template>{{ total }}</template>
                </el-table-column>
                <el-table-column label="已销售">
                    <template>{{itemData.sellStock}}</template>
                </el-table-column>
                <el-table-column label="待支付">
                    <template>{{itemData.occupyStock}}</template>
                </el-table-column>
                <el-table-column label="剩余">
                    <template><span :class="leftNum < 0 ? 'color-danger' : ''">{{leftNum}}</span></template>
                </el-table-column>
            </el-table>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultData = {
    type:1,
    num: undefined
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultData
            },
            rules:{
                num:[{ required: true, message: "请填写增/减数量", trigger:"blur" }]
            },
            itemData: null,
            index:0,
            total:0,
            leftNum:0
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultData
            }
        },
        show(data,index){
            this.itemData = data;
            this.index = index;
            this.changeStock();
            this.drawerShow = true;
        },
        changeStock(){
            this.total = this.formDatas.type == 1 ? 
                parseInt(this.itemData.totalStock) + parseInt(this.formDatas.num || 0) : 
                parseInt(this.itemData.totalStock) - parseInt(this.formDatas.num || 0)
            this.leftNum = this.total - parseInt(this.itemData.sellStock || 0) - parseInt(this.itemData.occupyStock || 0)
        },
        //表单提交
        submitForm() {
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/shop_good/adjustStocks',
                        data: {
                            ...this.formDatas,
                            goodsId: this.itemData.goodsId,
                            skuId: this.itemData.id
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('updateStock',{total:this.total,index:this.index});
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        },
    }
}
</script>